import React, { useRef, useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { useGoogleMapsLoader } from "../../utils/commonUtil";

interface AddressAutoCompleteProps {
  onPlaceSelected: (place: google.maps.places.PlaceResult | null, address: string | null) => void;
  country: string;
  initialValue?: string | null;
  className?: string;
}

const AddressAutoComplete: React.FC<AddressAutoCompleteProps> = ({
  onPlaceSelected,
  country,
  initialValue,
  className,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [address, setAddress] = useState(initialValue || "");
  const isLoaded = useGoogleMapsLoader();

  useEffect(() => {
    if (isLoaded && inputRef.current) {
      const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
        componentRestrictions: { country: country.toLowerCase() },
        types: ["address"],
      });

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        const newAddress = inputRef.current?.value || null;
        setAddress(newAddress || "");
        onPlaceSelected(place, newAddress);
      });
    }
  }, [isLoaded, onPlaceSelected, country]);

  useEffect(() => {
    setAddress(initialValue || "");
  }, [initialValue]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newAddress = event.target.value;
    setAddress(newAddress);
    onPlaceSelected(null, newAddress);
  };

  if (!isLoaded) {
    return <div>Loading...</div>;
  }

  return (
    <InputText
      ref={inputRef}
      placeholder="Enter a location"
      hidden={false}
      className={`w-full ${className || ""}`}
      onChange={handleInputChange}
      value={address}
    />
  );
};

export default AddressAutoComplete;
